import styled from 'styled-components';
export const ReviewMetadataRow = styled.div.withConfig({
  displayName: "StyledMetadataDetails__ReviewMetadataRow",
  componentId: "sc-1ojkxsq-0"
})(["display:flex;justify-content:start;margin-bottom:16px;"]);
export const ReviewMetadataColumn = styled.div.withConfig({
  displayName: "StyledMetadataDetails__ReviewMetadataColumn",
  componentId: "sc-1ojkxsq-1"
})(["display:flex;flex-direction:column;justify-content:start;flex:1;"]);
export const StyledMetadataValue = styled.span.withConfig({
  displayName: "StyledMetadataDetails__StyledMetadataValue",
  componentId: "sc-1ojkxsq-2"
})([""]);